import React from 'react';
import { FormControl, TextField } from '@material-ui/core';

import { UtilService } from 'app/services/util.service';
import { ControlContainer } from 'app/components/ControlContainer';
import { LastNameControlProps } from './LastNameControl.interfaces';
import { DoneAdornment } from 'app/components/DoneAdornment';
import { useLastNameControl } from 'app/shared/hooks/controls/useLastNameControl';

export default function LastNameControl(props: LastNameControlProps) {
  const {
    disabled,
    helperText,
    input,
    label,
    placeholder,
    meta,
    subLabel,
    tooltip,
    width,
  } = props;

  const {
    error,
    focused,
    handleBlur,
    handleChange,
    handleClick,
    isValueCheckVisible,
    onFocus,
  } = useLastNameControl(props);

  return (
    <ControlContainer
      inputId={input.name}
      tooltip={tooltip}
      helperText={helperText}
      isQuestionValid={props.isQuestionValid}
      floating
      floated={focused || UtilService.hasValue(input.value)}
      meta={meta}
      focused={focused}
      width={width}
    >
      <FormControl fullWidth>
        <TextField
          {...input}
          id={input.name}
          label={subLabel ? `${label} - ${subLabel}` : label}
          placeholder={placeholder}
          onChange={handleChange}
          onBlur={() => handleBlur()}
          onClick={handleClick}
          onFocus={onFocus}
          InputLabelProps={{
            shrink: UtilService.hasValue(input.value) || focused,
          }}
          InputProps={{
            startAdornment: isValueCheckVisible && <DoneAdornment />,
          }}
          error={error}
          variant={'outlined'}
          margin={'dense'}
          disabled={disabled}
        />
      </FormControl>
    </ControlContainer>
  );
}
